import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UserPasswordSetDialogComponent } from 'projects/shared/lib/components/shared/user/password-set-dialog/user-password-set-dialog.component';

@Component({
    selector: 'app-user-password-set-dialog',
    imports: [
        CommonModule,
        FormsModule,
    ],
    templateUrl: './user-password-set-dialog.component.html',
    styleUrls: ['./user-password-set-dialog.component.scss']
})
export class UserPasswordSetDialogMHComponent extends UserPasswordSetDialogComponent { }
